const ADD_PLUS = `
<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="Solid / add-plus">
<path id="Solid" fill-rule="evenodd" clip-rule="evenodd" d="M9 1.12891C4.44365 1.12891 0.75 4.82256 0.75 9.37891C0.75 13.9353 4.44365 17.6289 9 17.6289C13.5563 17.6289 17.25 13.9353 17.25 9.37891C17.25 4.82256 13.5563 1.12891 9 1.12891ZM9 5.62891C9.41421 5.62891 9.75 5.96469 9.75 6.37891V8.62891H12C12.4142 8.62891 12.75 8.96469 12.75 9.37891C12.75 9.79312 12.4142 10.1289 12 10.1289H9.75V12.3789C9.75 12.7931 9.41421 13.1289 9 13.1289C8.58579 13.1289 8.25 12.7931 8.25 12.3789V10.1289H6C5.58579 10.1289 5.25 9.79312 5.25 9.37891C5.25 8.96469 5.58579 8.62891 6 8.62891H8.25V6.37891C8.25 5.96469 8.58579 5.62891 9 5.62891Z" fill="#5C3CCD" stroke="none"/>
</g>
</svg>
`;

export default ADD_PLUS;
